<app-page [pageTitle]="'dashboard.dashboard'"
          template="dashboard"
          [pageinfo]="'dashboard.welcome' | translate:{ firstname: firstname$ | async }"
          [contentFullHeight]="false"
          [loader]="false">
  <ng-container actions>
    <app-autocorrect-consent-button></app-autocorrect-consent-button>
    <app-help-button template="dashboard"></app-help-button>
  </ng-container>
  <ng-container content>
    <div id="dashboard-grid">
      <app-chart [ngStyle]="{gridArea: 'a'}"></app-chart>
      <app-notifications-widget [ngStyle]="{gridArea: 'b'}"></app-notifications-widget>
      <app-metrics [slugs]="['ad-spend']" [ngStyle]="{gridArea: 'd'}"></app-metrics>
      <app-metrics [slugs]="['ad-clicks', 'site-sessions']" [ngStyle]="{gridArea: 'e'}"></app-metrics>
      <app-metrics [slugs]="['ad-conversions', 'site-transactions']" [ngStyle]="{gridArea: 'f'}"></app-metrics>
      <app-metrics [slugs]="['ad-revenue', 'site-revenue']" [ngStyle]="{gridArea: 'g'}"></app-metrics>
    </div>
  </ng-container>
</app-page>
